import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Helmet } from "react-helmet"
import { useI18next } from "gatsby-plugin-react-i18next"

const SEO = props => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          description
          descriptionEn
          siteUrl
          siteUrlEn
          title
          image
          imageEn
        }
      }
    }
  `)
  const { language } = useI18next()

  const {
    description,
    descriptionEn,
    siteUrl,
    siteUrlEn,
    title,
    image,
    imageEn,
  } = data.site.siteMetadata
  const { siteTitle, siteDesc } = props

  const getSiteDescription = () => {
    if (siteDesc) {
      return siteDesc
    } else if (language === "en") {
      return descriptionEn
    } else {
      return description
    }
  }

  const getSiteUrl = () => {
    if (language === "en") {
      return siteUrlEn
    } else {
      return siteUrl
    }
  }

  const getSiteImage = () => {
    if (language === "en") {
      return imageEn
    } else {
      return image
    }
  }

  const fullTitle = siteTitle ? `${siteTitle} | ${title}` : title

  return (
    <Helmet title={fullTitle} htmlAttributes={{ lang: language }}>
      <meta name="title" content={fullTitle} />
      <meta name="image" content={getSiteImage()} />
      <meta name="description" content={getSiteDescription()} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={getSiteUrl()} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={getSiteDescription()} />
      <meta property="og:image" content={getSiteImage()} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={getSiteUrl()} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={getSiteDescription()} />
      <meta name="twitter:image" content={getSiteImage()} />
    </Helmet>
  )
}

export default SEO
